// @ts-nocheck
import {
  SearchModule,
  mapGolazoNfts2Marketplace,
  NFTListingEditionCard,
  useMediaQuery,
} from '@dapperlabs/core-fe';
import type { NextPage } from 'next';
import React, { useMemo } from 'react';
import { useSession } from 'src/edge/session';
import Head from 'src/general/components/Head/Head';
import { MARKETPLACE_EXPANDED_FILTERS } from 'src/general/constants/localStorage';
import { useFeatureFlags } from 'src/lib/launchDarkly';
import { useAnalytics } from 'src/lib/segment';
import { useTranslation } from 'src/lib/translations';

// eslint-disable-next-line import/order
import {
  BROWSE_FILTER_OPTIONS as BROWSE_FILTER_OPTIONS_GOLAZO,
  // QUERY_FILTER_OPTIONS,
  parseOptions,
  BROWSE_SORT_OPTIONS as BROWSE_SORT_OPTIONS_GOLAZO,
  // QUERY_MARKETPLACE as QUERY_MARKETPLACE_EDITIONS_GOLAZO,
  GOLAZOS_NFT_AGGREGATION as QUERY_MARKETPLACE_EDITIONS_GOLAZO,
  VARIABLES_MARKETPLACE as VARIABLES_MARKETPLACE_EDITIONS_GOLAZO,
} from 'src/modules/searchGolazosNft';

// from core-fe
const SearchPage: NextPage = () => {
  const { isMarketplaceEnabled } = useFeatureFlags();
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const {
    state: {
      context: { preferredLanguage },
    },
  } = useSession();
  const [isMobile] = useMediaQuery('(max-width: 767px)');

  //Filter options
  // Memoize the category labels as each change causes page refretch & refetch.
  const filterOptions = useMemo(
    () => BROWSE_FILTER_OPTIONS_GOLAZO(t, { excludeFilterKeys: ['forSale'] }),
    // preferred language change means generate new categoryLabels
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preferredLanguage],
  );
  //Sort options
  const browseSortOptions = useMemo(
    () => BROWSE_SORT_OPTIONS_GOLAZO(t),
    // preferred language change means generate new categoryLabels
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preferredLanguage],
  );
  //Pagination options
  const paginationOptions = {
    itemPerPage: 48,
    queryPaginationPath: 'searchGolazosNftAggregation.pageInfo',
  };

  const searchControllerOptions = {
    browseSortOptions,
    expandedFiltersLocalStorageKey: MARKETPLACE_EXPANDED_FILTERS,
    filterOptions,
    options: {
      analyticsJsTrack: track,
      analyticsPrefix: 'laliga-marketplace-select',
    },
    paginationOptions,
    parseOptions,
    query: QUERY_MARKETPLACE_EDITIONS_GOLAZO,
    queryDataPath: 'searchGolazosNftAggregation',
    variables: VARIABLES_MARKETPLACE_EDITIONS_GOLAZO,
  };
  const copy = {
    BuyNow: t('MarketplaceSearch.BuyNow'),
    LowestAsk: t('MarketplaceSearch.LowestAsk'),
    MomentsBurned: t('MarketplaceSearch.MomentsBurned'),
    MomentsBurned_plural: t('MarketplaceSearch.MomentsBurned_plural'),
    ViewMomentDetails: t('MarketplaceSearch.ViewMomentDetails'),
    clearFilters: t('MarketplaceSearch.CTA.ClearAll'),
    done: isMobile
      ? t('MarketplaceSearch.CTA.ApplyFilters')
      : t('MarketplaceSearch.CTA.Done'),
    fetchMore: t('MarketplaceSearch.FetchMore'),
    filters: t('MarketplaceSearch.Filters'),
    loading: t('MarketplaceSearch.Loading'),
    result: t('MarketplaceSearch.SearchResults'),
    results: t('MarketplaceSearch.SearchResults_plural'),
    resultsEmpty: t('MarketplaceSearch.NoResults'),
    sortBy: t('MarketplaceSearch.SortBy'),
  };
  if (!isMarketplaceEnabled) return null;
  return (
    <>
      <Head
        description={t('Head.MarketplacePage.Description')}
        subtitle={t('Head.MarketplacePage.Subtitle')}
        title={t('Head.HomePage.Title')}
      />
      <SearchModule
        NFTListingEditionCard={NFTListingEditionCard}
        copy={copy}
        search2NFTListingEditionCard={mapGolazoNfts2Marketplace}
        searchControllerOptions={searchControllerOptions}
      />
    </>
  );
};

export default SearchPage;
